import * as React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import { useStyles } from './TopicsModalStyle';
import ModalRoutes from './modalRoutes/ModalRoutes';


export default function TopicModal() {
    const style = useStyles()
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <button className={style.configButton} onClick={handleOpen}>All configuration</button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={style.modal}>
                    <div className={style.modalHeader}>Topic Info</div>
                    <div style={{padding:"0px 30px 30px 30px"}}>
                        <ModalRoutes />
                    </div>

                </Box>
            </Modal>
        </div>
    );
}
